/* Petifo Q4 2026 campaign collection hero (templates/collection.campaign.json). Built 2026-10-16.
   Holiday = collection handle (server side). Dates/headline = snippets/pf-q4-campaign.liquid schedule.
   QA on another collection: ?view=campaign&pf_campaign=<key>. */
(function () {
  'use strict';
  function boot() {
    var sec = document.querySelector('.pfc');
    if (!sec || sec.hasAttribute('data-pfc-ready')) return;
    sec.setAttribute('data-pfc-ready', '');
    var cfg, S;
    try {
      cfg = JSON.parse(document.querySelector('[data-pfc-cfg]').textContent);
      S = JSON.parse(document.querySelector('[data-pfc-s]').textContent);
    } catch (e) { return; }
    var key = sec.getAttribute('data-pfc');
    if (!key && window.PF_Q4_KEY) { key = window.PF_Q4_KEY; sec.setAttribute('data-pfc', key); }
    var C = null;
    for (var i = 0; i < cfg.c.length; i++) if (cfg.c[i].key === key) C = cfg.c[i];
    if (!C) return;

    /* extra % (only differs when the key came from the QA preview) */
    var ex = sec.querySelector('[data-pfc-extra]');
    if (ex) ex.textContent = S.extra.replace(/__PCT__/g, String(C.extra));
    var exb = sec.querySelector('[data-pfc-extra-pct]');
    if (exb) exb.textContent = S.extraBig.replace(/__PCT__/g, String(C.extra));

    var START = Date.parse(C.start), END = Date.parse(C.end);
    var loc = S.locale || 'en';
    if (loc === 'en') loc = 'en-GB';
    function endText() {
      var d = new Date(END - 60000), a, b;
      try {
        a = new Intl.DateTimeFormat(loc, { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'Europe/Berlin' }).format(d);
        b = new Intl.DateTimeFormat(loc, { hour: '2-digit', minute: '2-digit', hourCycle: 'h23', timeZone: 'Europe/Berlin' }).format(d);
      } catch (e) { a = d.toDateString(); b = '23:59'; }
      return a + ', ' + b + ' ' + S.tz;
    }
    var valid = sec.querySelector('[data-pfc-valid]');
    var cd = sec.querySelector('[data-pfc-cd]');
    var lbl = sec.querySelector('[data-pfc-cd-l]');
    var U = {};
    ['d', 'h', 'm', 's'].forEach(function (u) { U[u] = cd && cd.querySelector('[data-u="' + u + '"]'); });
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    var timer = null;
    function tick() {
      var now = Date.now();
      if (now >= END) {
        if (cd) cd.hidden = true;
        if (valid) valid.textContent = S.ended;
        if (timer) clearInterval(timer);
        return;
      }
      var pre = now < START;
      var target = pre ? START : END;
      if (valid) valid.textContent = S.validUntil.replace('__DATE__', endText());
      if (lbl) lbl.textContent = pre ? S.startsIn : S.endsIn;
      var s = Math.max(0, Math.floor((target - now) / 1000));
      var d = Math.floor(s / 86400); s -= d * 86400;
      var h = Math.floor(s / 3600); s -= h * 3600;
      var m = Math.floor(s / 60); s -= m * 60;
      if (U.d) U.d.textContent = d;
      if (U.h) U.h.textContent = pad(h);
      if (U.m) U.m.textContent = pad(m);
      if (U.s) U.s.textContent = pad(s);
      if (cd) cd.hidden = false;
    }
    tick();
    timer = setInterval(tick, 1000);

    /* "Get my code" opens the existing Q4 sign-up popup (only exists while this holiday is live / previewed) */
    var btn = sec.querySelector('[data-pfc-code]');
    function wireCode() {
      var reopen = document.querySelector('[data-pf-q4-reopen]');
      var live = document.documentElement.getAttribute('data-pf-q4') === key;
      if (!btn || !reopen || !live || !document.querySelector('[data-pf-q4-pop]')) return false;
      btn.hidden = false;
      btn.addEventListener('click', function () { reopen.click(); });
      return true;
    }
    if (!wireCode()) setTimeout(wireCode, 1200);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
